export default {
  'menu.welcome': '欢迎',
  'menu.home': '首页',
  'menu.login': '登录',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': '分析页',
  'menu.dashboard.monitor': '监控页',
  'menu.dashboard.workplace': '工作台',
  'menu.merchant': '商家管理',
  'menu.merchant.info': '商家信息管理',
  'menu.merchant.audit': '商家审核管理',
  'menu.merchant.create': '新增商家',
  'menu.merchant.order': '商家充值订单管理',
  'menu.system': '系统管理',
  'menu.system.menu': '菜单管理',
  'menu.system.role': '角色管理',
  'menu.system.user': '用户管理',
  'menu.system.appVersion': 'App版本管理',
  'menu.taskManagement': '任务管理',
  'menu.taskManagement.management': '任务管理与追踪',
  'menu.taskManagement.audit': '任务审核',
  'menu.taskManagement.detail': '任务详情',
  'menu.taskManagement.managementMerchant': '已发布任务',
  'menu.taskManagement.taskProgress': '任务进度',
  'menu.taskManagement.managementTaskDetail': '任务详情',
  'menu.customer': '用户管理',
  'menu.customer.list': '用户信息管理',
  'menu.customer.tasks': '用户任务列表',
  'menu.customer.points': '用户提现结算',
  'menu.customer.tags': '用户标签管理',
  'menu.customer.batchAdjustPoints': '批量佣金调整',
  'menu.customer.withdrawalDateConfig': '提现日期设置',
  'menu.bill': '账单管理',
  'menu.bill.list': '服务费账单',
  'menu.customer.userApproval': '用户身份审核',
  'menu.customer.equipmentApproval': '设备申领审核',
  'menu.customer.employmentSupportApproval': '就业帮扶审核',
};
